import getters from './getters';
import mutations from './mutations';

const state = {
  storeList: [],
  productList: [],
  address: [],

  storeInfo: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
